<template>
  <SimpleDataTable
      :clickable-title="true"
      :title="'Alış Faturası Raporu'"
      :description="''"
      :dataList="purchaseReportData"
      :dataHeaders="purchaseReportHeaders"
      :loading="purchaseReportDataLoading"

  >
    <template v-slot:filterAndAction>
      <v-select
          v-model="purchaseReportTimePeriodFilterValue"
          :items="[
                      {value: 5, text: 'Tarih Aralığı'},
                      {value: 4, text: 'Yıllık'},
                      {value: 3, text: 'Aylık'},
                      {value: 2, text: 'Haftalık'},
                      {value: 1, text: 'Günlük'}
                  ]"
          style="width:100px;margin: 0 3px"
          label=""
          item-text="text"
          item-value="value"
          filled
          solo
          hide-details
          dense
          @change="purchaseReportTimePeriodFilterValue !== 5  ? _fetchPurchaseReport : null"
      >

      </v-select>
      <div v-if="purchaseReportTimePeriodFilterValue === 5">
        <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="formattedDate(purchaseReportDateRangeStartFilterValue)"
                placeholder="Filtre Başlangıç Tarihi"
                class="m-1"
                readonly
                filled
                solo
                dense
                clearable
                @click:clear="purchaseReportDateRangeStartFilterValue = null"
                hide-details
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="purchaseReportDateRangeStartFilterValue"
              locale="tr"
              :max="purchaseReportDateRangeEndFilterValue ? purchaseReportDateRangeEndFilterValue : 'NaN-Nan-Nan'"
          ></v-date-picker>
        </v-menu>
        <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="formattedDate(purchaseReportDateRangeEndFilterValue)"
                placeholder="Filtre Bitiş Tarihi"
                readonly
                solo
                filled
                class="m-1"
                dense
                clearable
                @click:clear="purchaseReportDateRangeEndFilterValue = null"
                hide-details
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="purchaseReportDateRangeEndFilterValue"
              locale="tr"
              :min="purchaseReportDateRangeStartFilterValue"
          ></v-date-picker>
        </v-menu>
        <div class="w-100 text-center">
          <v-btn
              x-small
              class="mx-auto"
              color="primary darken-2"
              @click="_fetchPurchaseReport"
          >
            FİLTRELE
          </v-btn>
        </div>
      </div>
    </template>
  </SimpleDataTable>
</template>

<script>

import SimpleDataTable from "@/components/dashboard/SimpleDataTable";
import {formattedDate} from "@/momentHelper";
import {mapActions, mapState} from "vuex";
import {numberConverter} from "../../../../helpers";

export default {
  name: "AlisFaturasiRaporu",
  components: {
    SimpleDataTable
  },
  props: {
    dashboardFilterCurrentCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterSalesPersonCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterReportDbNameProp: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState("settings", ["erpSettings"]),
    ...mapState("auth", ["user"])
  },
  mounted() {
    this._fetchPurchaseReport();
  },
  data() {
    return {
      purchaseReportHeaders: [],
      purchaseReportData: [],
      purchaseReportDataLoading: false,
      purchaseReportTimePeriodFilterValue: 4,
      purchaseReportDateRangeStartFilterValue: null,
      purchaseReportDateRangeEndFilterValue: null,
    }
  },
  methods: {
    numberConverter,
    ...mapActions("dashboard", ["fetchPurchaseReport","fetchCurrencyPurchaseReport"]),
    formattedDate,
    _fetchPurchaseReport() {

      this.purchaseReportDataLoading = true;

      const requestData = {
        params: {
          userId: this.user.UserId,
        },
        body: {
          ...(!(this.dashboardFilterCurrentCodeProp === "" || this.dashboardFilterCurrentCodeProp == null)) && {
            currentCode: this.dashboardFilterCurrentCodeProp,
          },
          ...(!(this.dashboardFilterSalesPersonCodeProp === "" || this.dashboardFilterSalesPersonCodeProp == null)) && {
            salesPersonCode: this.dashboardFilterSalesPersonCodeProp,
          },
          ...(!(this.dashboardFilterReportDbNameProp === "" || this.dashboardFilterReportDbNameProp == null)) && {
            reportDbName: this.dashboardFilterReportDbNameProp,
          },
          ...(!(this.purchaseReportTimePeriodFilterValue === "" || this.purchaseReportTimePeriodFilterValue == null)) && {
            DateType: this.purchaseReportTimePeriodFilterValue,
          },
          Type: 2,
        },
      };

      if (this.purchaseReportTimePeriodFilterValue === 5) {
        requestData.body.startDate = this.purchaseReportDateRangeStartFilterValue;
        requestData.body.endDate = this.purchaseReportDateRangeEndFilterValue;
      }

      this.fetchPurchaseReport(requestData).then(async (result) => {
        if (result && result.data.success) {
          this.purchaseReportData = [];
          this.purchaseReportData.push(result.data.data);
          this.purchaseReportData.map(item => item.vatExcludedAmount = this.numberConverter(item.vatExcludedAmount))
          this.purchaseReportHeaders = [
              {
                key: 'vatExcludedAmount',
                label: 'Tutar (TL)',
                sortable: false,
              }
          ]
          if (this.erpSettings.netsisCurrencySale) {
            await this.fetchCurrencyPurchaseReport(requestData).then(async (result) => {
              if (!result) {
                this.purchaseReportDataLoading = false;
                return;
              }
              result.data.data.map((item) => {
                this.purchaseReportHeaders.push({
                  key: item.currencyName,
                  label: item.currencySymbol,
                  sortable: false,
                  class: 'text-center pe-4'
                })
                let keytemp = `${item.currencyName}`;
                item[keytemp] = item.vatExcludedAmount;
                delete item.vatExcludedAmount;
                let existingItem = this.purchaseReportData[0];

                if (existingItem) {
                  existingItem[item.currencyName] = this.numberConverter(item[keytemp]);
                } else {
                  let newObj = {
                    [item.currencyName]: item[keytemp]
                  };
                  this.purchaseReportData.push(newObj);
                }
              });
              this.purchaseReportData.push(result.data.data);
            })
          }
        }
        this.purchaseReportDataLoading = false;
      })
    },
  },
  watch: {
    dashboardFilterCurrentCodeProp(newVal) {
      newVal;
      this._fetchPurchaseReport()
    },
    dashboardFilterSalesPersonCodeProp(newVal) {
      newVal;
      this._fetchPurchaseReport()
    },
    dashboardFilterReportDbNameProp(newVal) {
      newVal;
      this._fetchPurchaseReport()
    },
    purchaseReportTimePeriodFilterValue(newVal) {
      if (newVal === 5) return;
      this._fetchPurchaseReport()
    },
  }
}
</script>

<style scoped>

</style>